import { PieceSlider, PieceDescription, PieceUnorderedList } from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const financeApp = {
    name: 'Finance app',
    slug: 'finance-app',
    description: 'Service that provides financial accounting for the customers. It generates reports and sends them to appropriate instances.',
    cover: {
        url: `${PUBLIC_URL}/portfolio/finance/cover.jpg`,
        license: {
            link: 'http://www.freepik.com',
            text: 'Designed by Freepik'
        }
    },
    prominentColor: 'rgb(38,37,34)',
    pieces: [
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/portfolio/finance/data-statistics.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by fullvector / Freepik'
                    }
                },
                {
                    url: `${PUBLIC_URL}/portfolio/finance/tax.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Blossomstar / Freepik'
                    }
                },
                {
                    url: `${PUBLIC_URL}/portfolio/finance/cover.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            title: 'Role',
            description: 'Back-End developer',
        } as PieceDescription,
        {
            type: 'unordered list',
            title: 'Main Technologies',
            items: ['JAVA', 'Spring', 'Postgres', 'Hibernate', 'JasperReports'],
        } as PieceUnorderedList,
    ],
}

export default financeApp;


// WEBPACK FOOTER //
// ./src/store/portfolio/finance-app.tsx